import { RotateCw, TriangleAlert } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { isStaleBuildError } from "@/lib/stale-build";
import { cn } from "@/lib/utils";

import NotFoundPage from "../not-found";

/**
 * Marshrutdagi kutilmagan xato — panelning oxirgi to'sig'i.
 *
 * NEGA BU KERAK EDI. Router'da `errorElement` UMUMAN yo'q edi, ya'ni
 * har qanday render xatosi React Router'ning xom ekranini
 * ko'rsatardi — texnik stack bilan, panel korpusisiz. Admin uchun
 * bu "panel o'lgan" degani.
 *
 * ENG KO'P UCHRAYDIGAN SABAB — ESKI BUILD. Bu yerda har bir sahifa
 * `lazy()` bilan yuklanadi, ya'ni deploy'dan keyin ochiq qolgan
 * tabda BIRINCHI navigatsiyayoq yo'q bo'lgan bo'lakni so'raydi.
 * Admin panelni kun bo'yi ochiq ushlab turadi, deploy esa ish
 * kunining o'rtasida bo'ladi — ya'ni bu nazariy holat emas.
 *
 * O'shanda "qayta urinish" YORDAM BERMAYDI: u o'sha yo'q bo'lakni
 * yana so'raydi. Kerakli narsa — to'liq qayta yuklash.
 *
 * 404 ALOHIDA: `errorElement` marshrut topilmagan holatni ham
 * ushlaydi, va unga xato ekranini ko'rsatish yolg'on bo'lardi —
 * hech narsa buzilmagan, shunchaki manzil noto'g'ri.
 */
export default function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  const notFound = isRouteErrorResponse(error) && error.status === 404;
  const stale = isStaleBuildError(error);

  useEffect(() => {
    if (notFound || stale) return;

    console.error(error);
  }, [error, notFound, stale]);

  if (notFound) return <NotFoundPage />;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <span
        className={cn(
          "mb-5 grid size-14 place-items-center rounded-full",
          stale ? "bg-muted text-muted-foreground" : "bg-destructive/10 text-destructive",
        )}
      >
        {stale ? <RotateCw className="size-6" /> : <TriangleAlert className="size-6" />}
      </span>

      <h1 className="text-xl font-semibold">
        {stale ? t("errorPage.staleTitle") : t("errorPage.title")}
      </h1>
      <p className="text-muted-foreground mt-2 max-w-sm text-sm leading-relaxed">
        {stale ? t("errorPage.staleBody") : t("errorPage.body")}
      </p>

      <Button className="mt-6" onClick={() => window.location.reload()}>
        {stale ? t("errorPage.staleRetry") : t("errorPage.retry")}
      </Button>
    </div>
  );
}
